import { projectDataType } from ".";

const alienShipData: projectDataType = {
  path: "alienship",
  title: "Alien Ship",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1684964506/Art-Site/AlienShip/alienship_09_03_15.jpg",
  description:
    "A tongue in cheek self-portrait depicting an alien ship transporting away the artist as alien. The work was created as a short gif and an 20x30in aluminum image transfer.",
  detailedDescription: "",
  link: "",
  year: 2015,
  videos: ["https://vimeo.com/142605582?share=copy"],
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1684964506/Art-Site/AlienShip/alienship_09_03_15.jpg",
  ],
  installPhotos: [],
  invitations: [],
};

export default alienShipData;
